<template>
  <base-modal
    hide-footer
    :closeable-from-outside="false"
    :size="'lg'"
    :modal-id="'image-cropper-modal'"
    @hidden="$emit('onCloseModal')"
    @show="() => {}"
  >
    <template #modal-header>
      <div class="head-label">
        <span>Crop</span>
      </div>
    </template>
    <b-row>
      <b-col>
        <image-cropper
          :acceptFile="['.jpg', '.jpeg', '.png']"
          :image-url="imageUrl"
          @onCropImage="onCropImage"
          @onCloseModal="$emit('onCloseModal')"
        />
      </b-col>
    </b-row>
  </base-modal>
</template>

<script>
import BaseModal from "@/@core/components/base-modal/BaseModal.vue";
import ImageCropper from "@/views/components/image-cropper/ImageCropper.vue";
import { reactive, getCurrentInstance } from "@vue/composition-api";
export default {
  components: {
    BaseModal,
    ImageCropper,
  },
  props: {
    imageUrl: [String, Object],
  },
  setup() {
    const vm = getCurrentInstance().proxy;

    const onCropImage = (obj) => {
      vm.$emit("onCropImage", obj);
      vm.$emit("onCloseModal");
    };

    return {
      onCropImage,
    };
  },
};
</script>

<style scoped>
@import "~@/assets/css/pages/privilege/privilege-code-template/image-cropper-modal.css";
</style>